import { useEffect } from "react";

export default function Password() {
    useEffect(() => {
        window.location.replace("https://v1hj1w-3k.myshopify.com/password?_fd=0");
    }, []);

    return (
        <div className="max-w-[800px] mx-auto px-6 py-32 text-center">
            <h1 className="font-serif text-3xl mb-4">Connecting to Store Access...</h1>
            <p className="text-muted2 text-sm mb-6">Redirecting to store password authentication...</p>
            <a
                href="https://v1hj1w-3k.myshopify.com/password?_fd=0"
                className="inline-block bg-charcoal text-ivory px-6 py-3 text-xs tracking-editorial"
            >
                Continue to Password Page
            </a>
        </div>
    );
}
